import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from '../../../models/interfaces/components/Button.interface';
import { ButtonType } from '../../../models/enums/components/Button/ButtonType.enum';
import { ButtonColors } from '../../../models/enums/components/Button/ButtonColor.enum';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent implements Button {

  // INPUTS
  @Input()
  label:   string       = "";

  @Input()
  type:    ButtonType   = ButtonType.Default;

  @Input()
  color:   ButtonColors = ButtonColors.Default;

  @Input()
  active:  boolean      = false;

  @Input()
  disabled: boolean     = false;

  @Input()
  custom:   string[]    = []

  // OUTPUTS
  @Output()
  event:   EventEmitter<void> = new EventEmitter<void>();

  // PROPERTIES
  public readonly baseClass: string = "btn";

  // GETTERS
  public get classes(): string {
    
    const classes: string[] = [this.baseClass, this.type, this.color, ...this.custom];
    
    return classes.filter(cls => cls !== 'default').join(' ').concat(this.active ? ' active' : '');

  }

  // METHODS
  public onClick(): void {
    this.event.emit();
  }

}
